/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */


export enum FilterModesEnum {
    Global = 'global',
    CustomerSpecific = 'customerSpecific',
}